import { createTheme, ThemeOptions } from "@mui/material/styles";
import { ColorConf } from "../config/color";

declare module "@mui/material/styles" {
  interface Palette {
    custom: {
      primary: string;
      secondary: string;
      tertiary: string;
      primaryForWomen: string;
      secondaryForWomen: string;
      tertiaryForWomen: string;
      premium: string;
      accent: string;
      success: string;
      warning: string;
      error: string;
      info: string;
    };
  }
  interface PaletteOptions {
    custom?: {
      primary?: string;
      secondary?: string;
      tertiary?: string;
      primaryForWomen?: string;
      secondaryForWomen?: string;
      tertiaryForWomen?: string;
      premium?: string;
      accent?: string;
      success?: string;
      warning?: string;
      error?: string;
      info?: string;
    };
  }
}

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: ColorConf.Primary100,
      light: ColorConf.Primary25,
      dark: ColorConf.Primary100,
      contrastText: ColorConf.White
    },
    secondary: {
      main: ColorConf.Secondary,
      light: ColorConf.Accent25,
      dark: ColorConf.Accent100,
      contrastText: ColorConf.White
    },
    error: {
      main: ColorConf.Error100,
      light: ColorConf.DeleteRed,
      dark: ColorConf.BlockBackgroundRed
    },
    warning: {
      main: ColorConf.Warning100,
      light: ColorConf.SecondActive,
      dark: ColorConf.Gold
    },
    success: {
      main: ColorConf.Success100,
      light: ColorConf.Success75,
      dark: ColorConf.Active
    },
    info: {
      main: ColorConf.Info,
      light: ColorConf.Accent,
      dark: ColorConf.Tertiary
    },
    text: {
      primary: ColorConf.MainText,
      secondary: ColorConf.BaseText,
      disabled: ColorConf.TextLightGrey
    },
    background: {
      default: ColorConf.White,
      paper: ColorConf.MonoSecondaryBackground
    },
    custom: {
      primary: ColorConf.SecondaryForWomen,
      secondary: ColorConf.Secondary,
      tertiary: ColorConf.Tertiary,
      primaryForWomen: ColorConf.PrimaryForWomen,
      secondaryForWomen: ColorConf.SecondaryForWomen,
      tertiaryForWomen: ColorConf.TertiaryForWomen,
      premium: ColorConf.Premium,
      accent: ColorConf.Accent,
      success: ColorConf.Success100,
      warning: ColorConf.Warning100,
      error: ColorConf.Error100,
      info: ColorConf.Info
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 100,
          height: 40,
          textTransform: "none",
          fontWeight: 500,
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none"
          }
        },
        outlined: {
          borderWidth: 1,
          "&:hover": {
            borderWidth: 1
          }
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: false
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontFamily: '"Roboto", sans-serif',
          fontSize: "14px",
          fontWeight: 400,
          lineHeight: "20px",
          letterSpacing: "0.25px",
          color: ColorConf.MonoSecondaryText
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: ColorConf.MonoSecondaryText,
          "&.Mui-checked": {
            color: ColorConf.SecondaryForWomen
          },
          "&.Mui-disabled": {
            color: ColorConf.TextLightGrey
          }
        }
      }
    }
  }
};

export const theme = createTheme(themeOptions);
